import { useToast } from '@components/index'
import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'
import { useOnError } from '@services/utils/onError' // Added import
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { FlatDetail } from 'types/api'
import { BaseParams } from 'types/utils'
import { FlatWrite } from '../types'

export function useCreateFlat() {
  const toast = useToast()
  const { t } = useTranslation('toast')
  const queryClient = useQueryClient()
  const handleError = useOnError() // Added useOnError

  // TODO: add landlords and admins only implementation
  async function createFlat({
    body
  }: BaseParams<[FlatWrite, FlatDetail], 'POST'>) {
    const formData = new FormData()
    if (body) {
      Object.entries(body).forEach(([key, value]) => {
        // Truthiness must not decide here: `0` (e.g. a zero deposit) and
        // `false` are valid values that were previously dropped silently.
        if (value === undefined || value === null) return
        if (Array.isArray(value)) {
          if (value.length > 0)
            value.forEach((item) => formData.append(key, item as string | Blob))
        } else {
          formData.append(key, value as string | Blob)
        }
      })
    }
    const res = await apiClient.post<FlatDetail>(
      SNA_PREFIX + `flats`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
    return res.data
  }

  return useMutation({
    mutationFn: createFlat,
    onSuccess: (data, variables) => {
      variables?.params?.onSuccess?.(data)
      toast.success({ message: t('flatCreated') })
      queryClient.invalidateQueries({ queryKey: ['flats'] })
    },
    onError: handleError // Updated to use useOnError
  })
}
